//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ManualBet from './ManualBet.vue';

const BetType = {
    BALANCE: 'BALANCE',
    INVENTORY: 'INVENTORY'
};

export default {
    name: 'UiGameSidebar',
    components: { ManualBet },
    props: {
        modeName: {
            type: String,
            required: true
        },
        userBalanceUsd: {
            type: [Number, String],
            default: null
        },
        subtitle: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            required: true
        },
        roundId: {
            type: [Number, String],
            default: null
        },
        roundHash: {
            type: String,
            default: ''
        },
        gameMode: {
            type: String,
            required: true
        },
        balanceOnly: {
            type: Boolean,
            default: false
        },
        hasFairGame: {
            type: Boolean,
            default: true
        },
        autobetsEnabled: {
            type: Boolean,
            default: false
        },
        wagerEnabled: {
            type: Boolean,
            default: false
        },
        howItWorksSlides: {
            type: Array,
            default: null
        },
        minBetEnabled: {
            type: Boolean,
            default: false
        },
        fastAmounts:{ type: Array ,default: [0.25, 5, 10]},
        authState: {
            type: Object,
            default: () => ({})
        },
        // 补充缺失的 betAmountUsd prop
        betAmountUsd: {
            type: Number,
            default: 1.0
        }
    },
    data() {
        return {
            BetType,
            windowWidth: window.innerWidth,
            settingsState: {
                streamerMode: false
            }
        };
    },
    computed: {
        isLg() {
            return this.windowWidth <= 991;
        },
        // 兼顾 authState.betType 为函数或字符串的情况
        currentBetType() {
            if (!this.authState) return BetType.BALANCE;
            return typeof this.authState.betType === 'function'
                ? this.authState.betType()
                : (this.authState.betType || BetType.BALANCE);
        },
        // 兼顾 authState.isAuthenticated 为函数或布尔值的情况
        isAuthenticated() {
            if (!this.authState) return false;
            return typeof this.authState.isAuthenticated === 'function'
                ? this.authState.isAuthenticated()
                : !!this.authState.isAuthenticated;
        },
        // 读取当前金额
        internalBetAmount() {
            return this.betAmountUsd;
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.windowWidth = window.innerWidth;
        },
        handleAmountUpdate(val) {
            if (this.authState) {
                this.authState.betAmountUsd = val;
            }
            this.$emit('update:betAmountUsd', val);
            this.$emit('update:bet-amount-usd', val);
        },
        formatHash(hash) {
            if (!hash || hash.length < 64) return hash;
            return `${hash.slice(0, 6)} ... ${hash.slice(58, 64)}`;
        },
        copyRoundHash() {
            if (!this.roundHash) return;
            navigator.clipboard.writeText(this.roundHash).then(() => {
                this.$notify ? this.$notify({ type: 'success', message: '代码已复制' }) : alert('代码已复制');
                this.$emit('hash-copied', this.roundHash);
            });
        },
        openHowGameWorksDialog() {
            if (this.settingsState.streamerMode) return;
            this.$emit('open-how-it-works', { slides: this.howItWorksSlides });
        }
    }
};
